import { useInfiniteQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import {
  GetMultiplayerTournamentsParams,
  handleGetActiveTournaments,
} from "../../api-clients/tournamentsClient";
import { useMemo } from "react";
import { extractInfoFromInfiniteData, extractListRecords } from "../utils";

interface UseInfiniteActiveTournamentsQueryParams
  extends GetMultiplayerTournamentsParams {
  enabled?: boolean;
}

function useInfiniteActiveTournamentsQuery(
  params?: UseInfiniteActiveTournamentsQueryParams
) {
  const { gameId, limit, enabled = true } = params ?? {};

  const query = useInfiniteQuery({
    queryKey: [QUERY_KEYS.TOURNAMENT.ACTIVE_TOURNAMENTS, gameId],
    queryFn: ({ pageParam }) =>
      handleGetActiveTournaments({
        page: pageParam,
        limit,
        gameId,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => lastPage.nextPage,
    getPreviousPageParam: (firstPage) => firstPage.previousPage,
    enabled,
  });

  const activeTournamentList = useMemo(
    () => extractInfoFromInfiniteData(query.data),
    [query.data]
  );

  const activeTournaments = useMemo(
    () => extractListRecords(activeTournamentList),
    [activeTournamentList]
  );

  return { query, activeTournaments };
}

export default useInfiniteActiveTournamentsQuery;
